/**
 *
 *@author xujinjiang
 *@date 2022/7/12 13:42
 */
import { UrlConfig } from '@/config/UrlConfig';

export class OrderListUrlConfig {
  public static orderList = `${UrlConfig.websiteBaseurl}/thirdparty/order/list`;
}
